export default "__VITE_ASSET__Bw5o4ohU__"